__turbopack_context__.v({
  "action": "section-of-content-module-scss-module__LX0FMW__action",
  "action-fixed": "section-of-content-module-scss-module__LX0FMW__action-fixed",
  "block": "section-of-content-module-scss-module__LX0FMW__block",
  "box": "section-of-content-module-scss-module__LX0FMW__box",
  "box-default": "section-of-content-module-scss-module__LX0FMW__box-default" + " " + __turbopack_context__.i(789410)["pad-vertical"],
  "box-loading": "section-of-content-module-scss-module__LX0FMW__box-loading",
  "box-primary": "section-of-content-module-scss-module__LX0FMW__box-primary" + " " + __turbopack_context__.i(141992)["box-primary"],
  "list": "section-of-content-module-scss-module__LX0FMW__list",
  "subtitle": "section-of-content-module-scss-module__LX0FMW__subtitle",
  "with-reminder-link": "section-of-content-module-scss-module__LX0FMW__with-reminder-link",
});
